/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useStore } from '../../../store';

import ImgPoint from '../../../../../assets/animation_point.gif';
import ImgArrowLeft from '../../../../../assets/arrow-left-long.png';
import ImgArrowRight from '../../../../../assets/arrow-right-long.png';

import './component005.less';

import { Button, Modal, Tabs } from 'antd';

const { TabPane } = Tabs;

interface IComponent005Item {
  title: string;
  content: string;
  tip?: string;
  pic?: string;
  subtitle?: string;
  subItems?: IComponent005SubItem[];
}

interface IComponent005Props {
  items: {
    title?: string;
    tip?: string;
    pic?: string;
    items: IComponent005Item[];
  }[];
  onCompleted?: () => void;
  className?: string;
}

interface IComponent005SubItem {
  img: string;
  title: string;
  content: string;
  tip: string;
}

const Component005: React.FunctionComponent<IComponent005Props> = ({
  items,
  onCompleted,
  className,
}) => {
  const { updateParagraphState, language } = useStore();
  const settings =
    language === 'en'
      ? {
          viewlabel: 'Click here',
        }
      : {
          viewlabel: '點擊查看',
        };
  const [tabValue, setTabValue] = useState('1');
  const [completed, setCompleted] = useState(items.map((itm) => 0));
  const [lastClick, setLastClick] = useState(0);
  // const [play, setPlay] = React.useState(1);
  const [isModalOpen, setModalOpen] = useState(false);
  const [currPage, setCurrPage] = React.useState(0);
  // const [show, setShow] = useState<number[]>([]);
  const [show1, setShow1] = React.useState<number[]>([]);
  const [show2, setShow2] = React.useState<number[]>([]);
  const [modalItem, setModalItem] = useState<IComponent005SubItem[]>();

  const play = (index: number) => {
    setCompleted(
      completed.map((itm: any, idx: number) => (idx === index ? itm + 1 : itm))
    );
    setLastClick(lastClick + 1 < 4 ? lastClick + 1 : lastClick);
  };

  const setPage = (pagePlus: number) => {
    setCurrPage(currPage + pagePlus);
  };

  const [show, setShow] = useState(true);

  useEffect(() => {
    if (completed.some((itm, idx) => itm >= items[idx].items.length)) {
      onCompleted && onCompleted();
    }
  }, [completed]);

  useEffect(() => {
    if (tabValue === '2') {
      setShow(false);
    }
  }, [tabValue]);
  return (
    <div className={`component005 ${className || ''}`}>
      {/* <img className="click-point1" hidden={!show} src={ImgPoint} alt="" /> */}
      <Tabs
        type="card"
        className={`component005-topic-tab tab${tabValue}`}
        onChange={(activeKey) => setTabValue(activeKey)}
      >
        {items.map((itm: any, index: number) => (
          <TabPane tab={itm.title} key={`${index + 1}`}>
            <div className="component005-component003">
              {itm.tip && (
                <>
                  <div className="component003-tip">
                    <span
                      className="tip-text"
                      dangerouslySetInnerHTML={{ __html: itm.tip }}
                    />
                    <div className="tip-arrow">
                      <div className="line1" />
                      <div className="line2" />
                    </div>
                  </div>
                  <img
                    src={require(`../../../../../assets/${itm.pic}`).default}
                    alt=""
                  />
                </>
              )}
              {itm.items[lastClick]?.tip && (
                <>
                  <div className="component003-tip">
                    <span
                      className="tip-text"
                      dangerouslySetInnerHTML={{
                        __html: itm.items[lastClick]?.tip,
                      }}
                    />
                    <div className="tip-arrow">
                      <div className="line1" />
                      <div className="line2" />
                    </div>
                  </div>
                  <img
                    src={
                      require(`../../../../../assets/${itm.items[lastClick]?.pic}`)
                        .default
                    }
                    alt=""
                  />
                </>
              )}
            </div>
            <div className="component005-card-tab">
              <div className="component005-card-list">
                {itm.items.map((card: IComponent005Item, idx: number) => (
                  <div
                    key={idx}
                    className={`component005-card-item r${idx + 1}`}
                    style={{ width: `${(1 / itm.items.length) * 100}%` }}
                  >
                    <div className="component005-card-item-title en-line-height-21">
                      <div dangerouslySetInnerHTML={{ __html: card.title }} />
                    </div>
                    <div className="component005-card-item-content en-line-height-21">
                      <div className="text">
                        {card.subtitle ? (
                          <>
                            {card.content}
                            <span
                              className="view-more"
                              onClick={() => {
                                setModalOpen(true);
                                setModalItem(card.subItems);
                                setShow(false);
                              }}
                            >
                              <Button className="view-more-btn" type="link">
                                {card.subtitle}
                              </Button>
                              <img
                                className="click-point1"
                                hidden={!show}
                                src={ImgPoint}
                                alt=""
                              />
                            </span>
                          </>
                        ) : (
                          <div
                            className="text"
                            dangerouslySetInnerHTML={{ __html: card.content }}
                          />
                        )}
                      </div>
                    </div>
                    {completed[index] < idx && (
                      <div className="clickable" onClick={() => play(index)}>
                        <div className="clickable-label">
                          {settings.viewlabel}
                        </div>
                        {completed[index] === idx - 1 && (
                          <img className="click-point" src={ImgPoint} alt="" />
                        )}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </TabPane>
        ))}
      </Tabs>
      {modalItem && (
        <Modal
          width="80%"
          className="component005-modal-general2024"
          title={
            <div className="component005-modal-header">
              {modalItem[currPage]?.title}
            </div>
          }
          footer={null}
          open={isModalOpen}
          onCancel={() => {
            setModalOpen(false);
            setCurrPage(0);
          }}
        >
          <div className="border">
            <img
              src={
                require(`../../../../../assets/${modalItem[currPage]?.img}`)
                  .default
              }
              alt=""
            />
          </div>
          {modalItem.length > 0 && modalItem[currPage]?.content && (
            <>
              <div
                className="tip"
                dangerouslySetInnerHTML={{
                  __html: modalItem[currPage]?.tip,
                }}
              />
              <div
                className="content"
                dangerouslySetInnerHTML={{
                  __html: modalItem[currPage]?.content,
                }}
              />
            </>
          )}
          <Button
            className={`prev-button ${currPage === 0 ? 'hide' : ''}`}
            type="text"
            disabled={currPage === 0}
            onClick={() => {
              setPage(-1);
              setShow2([...show2, currPage]);
            }}
          >
            <img className="arrow" src={ImgArrowLeft} alt="" />
            <img
              className="click-point1"
              hidden={!show}
              src={ImgPoint}
              alt=""
            />
          </Button>

          <Button
            className={`next-button ${
              currPage === modalItem.length - 1 ? 'hide' : ''
            }`}
            type="text"
            disabled={currPage === modalItem.length - 1}
            onClick={() => {
              setPage(1);
              setShow1([...show1, currPage]);
            }}
          >
            <img className="arrow" src={ImgArrowRight} alt="" />
            <img
              className="click-point2"
              hidden={show1.includes(currPage)}
              src={ImgPoint}
              alt=""
            />
          </Button>
        </Modal>
      )}
    </div>
  );
};

export default Component005;
